/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlingUnitType } from './HandlingUnitType';
import {
    HandlingUnitTypeFromJSON,
    HandlingUnitTypeFromJSONTyped,
    HandlingUnitTypeToJSON,
    HandlingUnitTypeToJSONTyped,
} from './HandlingUnitType';
import type { TemperatureHandling } from './TemperatureHandling';
import {
    TemperatureHandlingFromJSON,
    TemperatureHandlingFromJSONTyped,
    TemperatureHandlingToJSON,
    TemperatureHandlingToJSONTyped,
} from './TemperatureHandling';

/**
 * Represents a line item
 * @export
 * @interface LineItemInfoDraft
 */
export interface LineItemInfoDraft {
    /**
     * 
     * @type {HandlingUnitType}
     * @memberof LineItemInfoDraft
     */
    handlingUnitType?: HandlingUnitType;
    /**
     * 
     * @type {number}
     * @memberof LineItemInfoDraft
     */
    numberHandlingUnits?: number;
    /**
     * 
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItemInfoDraft
     */
    lengthInches?: number;
    /**
     * 
     * @type {number}
     * @memberof LineItemInfoDraft
     */
    widthInches?: number;
    /**
     * 
     * @type {number}
     * @memberof LineItemInfoDraft
     */
    heightInches?: number;
    /**
     * 
     * @type {number}
     * @memberof LineItemInfoDraft
     */
    weightPerHandlingUnitPounds?: number;
    /**
     * 
     * @type {TemperatureHandling}
     * @memberof LineItemInfoDraft
     */
    temperatureHandling?: TemperatureHandling;
    /**
     * 
     * @type {boolean}
     * @memberof LineItemInfoDraft
     */
    isDangerous?: boolean;
    /**
     * The National Motor Freight Classification (NMFC) item number for this shipment. For more details, see: [NMFC Code Guide](https://help.freightsimple.com/freight-101/nmfc-codes-and-freight-class).
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    nmfcItemNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LineItemInfoDraft
     */
    isStackable?: boolean;
    /**
     * The UN number assigned to the hazardous material, as defined by the United Nations classification system. (e.g. UN0234)<br/>Required if the line item is dangerous
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    dangerousUnNumber?: string;
    /**
     * The hazard classification of the material, indicating the type of danger it presents (e.g. 1).<br/>Required if the line item is dangerous
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    dangerousClassification?: string;
    /**
     * The packing group (I, II, or III) that indicates the level of danger, where I is the most hazardous and III is the least.<br/>Required if the line item is dangerous
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    dangerousPackingGroup?: string;
    /**
     * The official shipping name for the hazardous material, as specified in the regulations.<br/>Required if the line item is dangerous
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    dangerousProperShippingName?: string;
    /**
     * The precise technical name of the material, providing more detailed identification beyond the proper shipping name.<br/>Optional. When the shipment picks up or delivers in Canada and the UN number carries TDG special provision 16, the technical name must appear on the bill of lading - supply it to keep the TDG declaration complete.
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    dangerousTechnicalName?: string;
    /**
     * Number of packages within each handling unit eg. If you are shipping a crate containing 50 bags, enter 50. If you are shipping a drum that is not further subdivided, enter 1<br/>Required if the line item is dangerous. Between 1 and 99,999.
     * @type {number}
     * @memberof LineItemInfoDraft
     */
    dangerousNumberPackages?: number;
    /**
     * Number of packages within each handling unit eg. If you are shipping a crate containing 50 bags, enter bag. If you are shipping a drum that is not further subdivided, enter drum<br/>Required if the line item is dangerous
     * @type {string}
     * @memberof LineItemInfoDraft
     */
    dangerousPackagingType?: string;
    /**
     * Net explosive quantity in kilograms. Optional. For a Class 1 explosive (classification starts with 1) on a shipment that picks up or delivers in Canada, this must appear on the bill of lading - supply it when known. Must be greater than zero when provided; capped at the heaviest shipment we accept (48,000 lb).
     * @type {number}
     * @memberof LineItemInfoDraft
     */
    dangerousNetExplosiveQuantityKg?: number;
}



/**
 * Check if a given object implements the LineItemInfoDraft interface.
 */
export function instanceOfLineItemInfoDraft(value: object): value is LineItemInfoDraft {
    return true;
}

export function LineItemInfoDraftFromJSON(json: any): LineItemInfoDraft {
    return LineItemInfoDraftFromJSONTyped(json, false);
}

export function LineItemInfoDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItemInfoDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'handlingUnitType': json['handlingUnitType'] == null ? undefined : HandlingUnitTypeFromJSON(json['handlingUnitType']),
        'numberHandlingUnits': json['numberHandlingUnits'] == null ? undefined : json['numberHandlingUnits'],
        'description': json['description'] == null ? undefined : json['description'],
        'lengthInches': json['lengthInches'] == null ? undefined : json['lengthInches'],
        'widthInches': json['widthInches'] == null ? undefined : json['widthInches'],
        'heightInches': json['heightInches'] == null ? undefined : json['heightInches'],
        'weightPerHandlingUnitPounds': json['weightPerHandlingUnitPounds'] == null ? undefined : json['weightPerHandlingUnitPounds'],
        'temperatureHandling': json['temperatureHandling'] == null ? undefined : TemperatureHandlingFromJSON(json['temperatureHandling']),
        'isDangerous': json['isDangerous'] == null ? undefined : json['isDangerous'],
        'nmfcItemNumber': json['nmfcItemNumber'] == null ? undefined : json['nmfcItemNumber'],
        'isStackable': json['isStackable'] == null ? undefined : json['isStackable'],
        'dangerousUnNumber': json['dangerousUnNumber'] == null ? undefined : json['dangerousUnNumber'],
        'dangerousClassification': json['dangerousClassification'] == null ? undefined : json['dangerousClassification'],
        'dangerousPackingGroup': json['dangerousPackingGroup'] == null ? undefined : json['dangerousPackingGroup'],
        'dangerousProperShippingName': json['dangerousProperShippingName'] == null ? undefined : json['dangerousProperShippingName'],
        'dangerousTechnicalName': json['dangerousTechnicalName'] == null ? undefined : json['dangerousTechnicalName'],
        'dangerousNumberPackages': json['dangerousNumberPackages'] == null ? undefined : json['dangerousNumberPackages'],
        'dangerousPackagingType': json['dangerousPackagingType'] == null ? undefined : json['dangerousPackagingType'],
        'dangerousNetExplosiveQuantityKg': json['dangerousNetExplosiveQuantityKg'] == null ? undefined : json['dangerousNetExplosiveQuantityKg'],
    };
}

  export function LineItemInfoDraftToJSON(json: any): LineItemInfoDraft {
      return LineItemInfoDraftToJSONTyped(json, false);
  }

  export function LineItemInfoDraftToJSONTyped(value?: LineItemInfoDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handlingUnitType': HandlingUnitTypeToJSON(value['handlingUnitType']),
        'numberHandlingUnits': value['numberHandlingUnits'],
        'description': value['description'],
        'lengthInches': value['lengthInches'],
        'widthInches': value['widthInches'],
        'heightInches': value['heightInches'],
        'weightPerHandlingUnitPounds': value['weightPerHandlingUnitPounds'],
        'temperatureHandling': TemperatureHandlingToJSON(value['temperatureHandling']),
        'isDangerous': value['isDangerous'],
        'nmfcItemNumber': value['nmfcItemNumber'],
        'isStackable': value['isStackable'],
        'dangerousUnNumber': value['dangerousUnNumber'],
        'dangerousClassification': value['dangerousClassification'],
        'dangerousPackingGroup': value['dangerousPackingGroup'],
        'dangerousProperShippingName': value['dangerousProperShippingName'],
        'dangerousTechnicalName': value['dangerousTechnicalName'],
        'dangerousNumberPackages': value['dangerousNumberPackages'],
        'dangerousPackagingType': value['dangerousPackagingType'],
        'dangerousNetExplosiveQuantityKg': value['dangerousNetExplosiveQuantityKg'],
    };
}

